export default {
  edit: JSON.parse(process.env.REACT_APP_FLAG_EDIT || false),
  registration: JSON.parse(process.env.REACT_APP_FLAG_REGISTRATION || false),
  customEmailType: JSON.parse(process.env.REACT_APP_FLAG_EMAIL_TYPE || false),
  offerLimit: JSON.parse(process.env.REACT_APP_OFFER_LIMIT || false)
};
